import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { callApi } from "../common/Apicall";
import {
  setWithMessagesConversations,
  setWithMessagesGroups,
} from "../Slices/ChatSlice";

const useGetConversations = (shouldFetch, conversationType) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const URL = process.env.REACT_APP_URL;

  useEffect(() => {
    if (!shouldFetch && !conversationType) return; // If both are false, skip fetching

    const getConversations = async () => {
      setLoading(true);
      try {
        if (shouldFetch && !conversationType) {
          // Fetch both conversations and group conversations
          const [conversationsRes, groupRes] = await Promise.all([
            callApi(`${URL}/Chats/users-with-messages`, "GET"),
            callApi(`${URL}/GroupChat/Users-With-GroupMessages`, "GET"),
          ]);

          if (conversationsRes.error || groupRes.error) {
            throw new Error(conversationsRes.error || groupRes.error);
          } else {
            dispatch(setWithMessagesConversations(conversationsRes || []));
            dispatch(setWithMessagesGroups(groupRes));
          }
        } else {
          // Fetch based on conversationType
          let res;
          if (conversationType === "group") {
            res = await callApi(
              `${URL}/GroupChat/Users-With-GroupMessages`,
              "GET"
            );
            // dispatch(setWithMessagesConversations(res));
            
          } else {
            res = await callApi(`${URL}/Chats/users-with-messages`, "GET");
            dispatch(setWithMessagesConversations( res || []));
          }

          if (res.error) {
            throw new Error(res.error);
          }
        }
      } catch (error) {
        console.log(error.message, "Error fetching conversations");
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    };

    getConversations();
  }, [shouldFetch, conversationType]); // Effect depends on shouldFetch and conversationType

  return { loading };
};

export default useGetConversations;
